// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2UOLk","additionalInfo":"AgreementModal_additionalInfo__1FbuX"};